import { render, staticRenderFns } from "./HkiaraceBanner.vue?vue&type=template&id=5bb17920"
import script from "./HkiaraceBanner.vue?vue&type=script&lang=js"
export * from "./HkiaraceBanner.vue?vue&type=script&lang=js"
import style0 from "./HkiaraceBanner.vue?vue&type=style&index=0&id=5bb17920&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports